import React from "react";

interface Prop {
  title: string;
  mobileMarginBottom?: string;
}

const InfoTitle: React.FC<Prop> = ({ title, mobileMarginBottom }) => {
  return (
    <>
      <div
        className={`text-left bg-grey px-3 rounded-[10px] py-3 font-Mulish text-darkgrey font-semibold text-[16px] md:text-[16px] mb-4 ${mobileMarginBottom}`}
      >
        <h6>{title}</h6>
      </div>
    </>
  );
};

export default InfoTitle;
